/**
 * Created by ivo on 14.05.14.
 */
define([
        'jQuery',
        'underscore',
        'clientComponents/inlinemodal/inlineModal',
        'clientComponents/favoriteshandler/favoritesHandler',
        'library/fcse-request/multiRequestHandler',
        'clientComponents/lastvisited/lastVisitedHotelSlider',
        'clientComponents/googletagmanager/GtmManager',
        'clientComponents/navbarmenu/NavbarMenu',
        './common_mobile',
        'respond'
    ],
    function ($, _, InlineModal, FavoritesHandler, MultiRequestHandler,
              LastVisitedHotelSlider, GtmManager) {
        if ($('[data-fcse-role=inline-click-modal]').length && $('[data-fcse-role=inline-modal-trigger]').length) {
          // Initialize service modals
          var inlineModalOnClick = new InlineModal('[data-fcse-role=inline-click-modal]', {
              autoHide: false,
              hideOnLeave: false,
              triggerEventName: 'click'
            }
          );
        }

        if ($('[data-fcse-role=inline-modal]').length) {
          var inlineModal = new InlineModal('[data-fcse-role=inline-modal]',
            {
              autoHide: false,
              hideOnLeave: false,
              triggerEventName: 'mouseover'
            });
        }

        var requestHandler = new MultiRequestHandler();
        var favoritesHandler = new FavoritesHandler(requestHandler);
        var lastVisitedHotels = new LastVisitedHotelSlider('[data-fcse-role="last-visited-hotels-slider"]',
            {route: 'allt_frontend.user_tracking.last_visited'});

        $('#navbar [data-fcse-role="navbar-container"]')
            .on('follow.navbar-menu', '[data-toggle="navbar-menu"]', function (e) {
                $('body').trigger('gtm.analyticsEvent', {source: 'navbarToggle', event: e});
            });

        GtmManager.initEventTracker({});

        var Common = function () {
        };

        return Common;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/common.js